module.exports = __webpack_public_path__ + "img/carl-pro.1595b538.jpg";